import { __assign } from "tslib";
import React from 'react';
import { Select, Box, Grid, Image, HStack } from '@chakra-ui/react';
import { noop, formatNumber } from "../../utils";
export var TableOrder = function TableOrder(props) {
  var id = props.id,
      price = props.price,
      net = props.net,
      name = props.name,
      amount = props.amount,
      _a = props.onChangePackage,
      onChangePackage = _a === void 0 ? noop : _a,
      image = props.image;
  return /*#__PURE__*/React.createElement(Box, {
    border: "1px solid",
    borderColor: "gray.200",
    borderRadius: "8px"
  }, /*#__PURE__*/React.createElement(Grid, {
    fontSize: "xl",
    minHeight: "72px",
    gridTemplateColumns: "1fr max-content",
    alignItems: "center",
    p: "2",
    pl: "6"
  }, /*#__PURE__*/React.createElement(Box, {
    fontWeight: "bold"
  }, "\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D")), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Grid, {
    fontSize: "sm",
    gridTemplateColumns: "1fr minmax(100px, 150px) minmax(100px, 150px) minmax(100px, 150px)",
    textAlign: "right"
  }, /*#__PURE__*/React.createElement(Box, __assign({
    textAlign: "left",
    pl: "6"
  }, tableHeadStyles), "\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23"), /*#__PURE__*/React.createElement(Box, __assign({}, tableHeadStyles), "\u0E08\u0E33\u0E19\u0E27\u0E19"), /*#__PURE__*/React.createElement(Box, __assign({}, tableHeadStyles), "\u0E08\u0E33\u0E19\u0E27\u0E19\u0E40\u0E07\u0E34\u0E19"), /*#__PURE__*/React.createElement(Box, __assign({
    pr: "6"
  }, tableHeadStyles), "\u0E22\u0E2D\u0E14\u0E23\u0E27\u0E21 (\u0E1A\u0E32\u0E17)"), /*#__PURE__*/React.createElement(HStack, __assign({
    textAlign: "left",
    ml: "6"
  }, columnStyles), image && /*#__PURE__*/React.createElement(Image, {
    src: image,
    alt: "",
    h: "48px",
    w: "48px",
    objectFit: "contain"
  }), /*#__PURE__*/React.createElement(Box, {
    fontWeight: "bold"
  }, name)), /*#__PURE__*/React.createElement(Box, __assign({}, columnStyles), /*#__PURE__*/React.createElement(Box, null, props.recurring ? /*#__PURE__*/React.createElement(Select, {
    size: "sm",
    defaultValue: props.recurring,
    onChange: function onChange(e) {
      onChangePackage({
        packageId: id,
        recurring: e.target.value
      });
    }
  }, /*#__PURE__*/React.createElement("option", {
    value: "month"
  }, "\u0E23\u0E32\u0E22\u0E40\u0E14\u0E37\u0E2D\u0E19"), /*#__PURE__*/React.createElement("option", {
    value: "year"
  }, "\u0E23\u0E32\u0E22\u0E1B\u0E35")) : amount)), /*#__PURE__*/React.createElement(Box, __assign({}, columnStyles), formatNumber(price)), /*#__PURE__*/React.createElement(Box, __assign({
    mr: "6"
  }, columnStyles), formatNumber(net)))));
};
export var columnStyles = {
  borderColor: 'gray.200',
  pt: '2',
  pb: '2'
};
export var tableHeadStyles = {
  fontWeight: 'bold',
  color: '#555',
  borderTop: '1px solid',
  borderColor: 'gray.200',
  pt: '2',
  pb: '2'
};